import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { ScheduleService } from 'services/ScheduleService';
import { ShiftProfile } from 'repository/schedule/@types/ShiftProfile';
import { FormShiftProfile } from './FormShiftProfile';
import { ShiftProfileFormValues } from 'schemas/ShiftProfile';

interface UpdateProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: any;
    rowToEdit: ShiftProfile;
    reloading: () => void;
}

const scheduleService = new ScheduleService();

export const UpdateShiftProfile: FC<UpdateProps> = ({ open, setOpen, rows, rowToEdit, reloading }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values: ShiftProfileFormValues) => {
        const payload: ShiftProfile = {
            ...rowToEdit,
            shift_profile_name: values.name,
            shift_profile_description: values.description || undefined,
            is_night: values.is_night,
            min_start_time: values.start_time_min,
            max_start_time: values.start_time_max,
            min_end_time: values.end_time_min,
            max_end_time: values.end_time_max,
            standard_duration: values.duration_standard,
            min_duration: values.duration_min,
            max_duration: values.duration_max,
        };

        try {
            await scheduleService.shift_profile.update(payload.shift_profile_id, payload);
            enqueueSnackbar('Perfil de turno actualizado', { variant: 'success' });
            reloading();
        } catch (error) {
            console.error(error);
            enqueueSnackbar(t('general.errors.unexpected'), { variant: 'error' });
            throw error;
        }
    };

    return (
        <FormShiftProfile
            open={open}
            setOpen={setOpen}
            rows={rows}
            initialValues={{
                id: rowToEdit?.id,
                name: rowToEdit?.shift_profile_name,
                description: rowToEdit?.shift_profile_description ?? '',
                is_night: rowToEdit?.is_night ?? false,
                start_time_min: rowToEdit?.min_start_time,
                start_time_max: rowToEdit?.max_start_time,
                end_time_min: rowToEdit?.min_end_time,
                end_time_max: rowToEdit?.max_end_time,
                duration_standard: rowToEdit?.standard_duration,
                duration_min: rowToEdit?.min_duration,
                duration_max: rowToEdit?.max_duration,
            }}
            titleKey={'Editar perfil de turno'}
            onSubmit={handleSubmit}
        />
    );
};
